import { render, staticRenderFns } from "./FieldProperties.vue?vue&type=template&id=d98331ea&scoped=true"
import script from "./FieldProperties.vue?vue&type=script&lang=js"
export * from "./FieldProperties.vue?vue&type=script&lang=js"
import style0 from "./FieldProperties.vue?vue&type=style&index=0&id=d98331ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98331ea",
  null
  
)

export default component.exports